import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './../GrapeAPIError'

interface MemberEligibility {
  given_name: string
  last_name: string
  email: string
  eligible: boolean
  ineligible_reason: string | null
  month: string
  commission: string
}

export const useGetPayoutMemberEligibilities = (ledgerId: string, options?: { enabled?: boolean }) =>
  useQuery<
    { data: { member_eligibilities: MemberEligibility[]; employer_name: string; month: string } },
    GrapeAPIErrorType
  >({
    queryKey: ['payoutMemberEligibilities', ledgerId],
    enabled: options?.enabled,
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/broker/payouts/details/${ledgerId}`
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json()
    },
  })
